import { DateTime } from 'luxon';

export function formatISO(iso: string, format = 'LLL dd, t') {
  return DateTime.fromISO(iso).toFormat(format);
}

/**
 * Helper function to convert a date to a DateTime object while keeping the local time.
 * @param date
 * @param timezone
 * @return DateTime
 */
export function dateToDateTime(date: Date, timezone: string): DateTime {
  return DateTime.fromJSDate(date, { zone: timezone }).setZone(DateTime.local().zoneName, { keepLocalTime: true });
}

/**
 * Helper function to convert a local date to a specific timezone date.
 * Used for converting a local date to a patient's timezone.
 * @param date Date
 * @param timezone string
 * @return Date
 */
export function localDateToSpecificTimeZoneDate(date: Date, timezone: string): Date {
  return dateToDateTime(date, timezone).toJSDate();
}

export function dateTimeToLocalDateSameTime(dateTime: DateTime): Date {
  return dateTime.setZone(DateTime.local().zoneName, { keepLocalTime: true }).toJSDate();
}

export function dateToUTCString(date: Date, timezone: string): string {
  return DateTime.fromJSDate(date).setZone(timezone, { keepLocalTime: true }).toUTC().toISO() ?? '';
}

export function maximumDateInUTCString(): string {
  return (
    DateTime.fromObject(
      {
        year: 2050,
        month: 1,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
      },
      {
        zone: 'utc',
      },
    ).toISO() ?? ''
  );
}
